<template>
  <div>
    <AdminPortalPage v-if="isFullLayout" />
    <AdminPortalMain
      v-else
      :activeRoute="activeRoute"
      :headerTitle="pageTitle"
      :returnPath="returnPath"
      :tooltipProps="tooltipProps"
    />
    <TheModal
      ref="theModal"
      :class="$style.modalContainer"
    />
  </div>
</template>

<script>
import AdminPortalMain from 'client/AdminPortalMain.vue';
import AdminPortalPage from 'client/AdminPortalPage.vue';
import LoggingService from 'client/util/LoggingService';
import TheModal from 'client/components/Modal/TheModal.vue';
import globalRouteService from 'client/AdminPortal/router/globalRouteService';

export default {
  name: 'AdminPortalApp',

  components: {
    AdminPortalPage,
    AdminPortalMain,
    TheModal,
  },

  globalRouteService,

  data() {
    return {
      activeRoute: '',
      backboneTitle: '',
      backbonePlatformPlus: null,
      backboneTooltipProps: {
        linkHref: '',
        pText: '',
      },
    };
  },

  computed: {
    isFullLayout() {
      return this.$route.meta.layout === 'fullpage';
    },

    isVueRoute() {
      return this.$route.matched.length > 0;
    },

    pageTitle() {
      return (this.isVueRoute ? this.$route.meta.title : this.backboneTitle) || '';
    },

    returnPath() {
      return this.isVueRoute ? this.$route.meta.returnPath : '';
    },

    tooltipProps() {
      return this.isVueRoute ? this.$route.meta.tooltipProps : this.backboneTooltipProps;
    },
  },

  watch: {
    $route: {
      handler(newValue, oldValue) {
        const toBackbone = newValue.matched.length === 0;

        LoggingService.debug('AdminPortalApp.watch.$route', { newValue, oldValue, $route: this.$route });

        if (toBackbone && oldValue != null) {
          this.$options.globalRouteService.kickBackboneApp();
        } else if (!toBackbone) {
          this.$options.globalRouteService.cleanUpBackboneApp();
        }

        this.updateActiveRoute(newValue.fullPath);
      },

      immediate: true,
    },
  },

  mounted() {
    this.$options.globalRouteService.onUpdateRoute(newRoute => this.updateActiveRoute(newRoute));
  },

  methods: {
    /**
     * This method is called from the legacy Viewport Backbone view when rendering
     * backbone views in the Vue application. When the Backbone router is routing
     * pages the Viewport will set the platformPlus config.
     */
    setPlatformPlus(platformPlus) {
      this.backbonePlatformPlus = platformPlus;
    },

    setTitle(title) {
      this.backboneTitle = title;
    },

    /**
     * This method is called from the legacy Viewport Backbone view when rendering
     * backbone views in the Vue application. When the Backbone router is routing
     * pages the Viewport will set the platformPlus config.
     */
    setTooltip(tooltipProps) {
      this.backboneTooltipProps = tooltipProps;
    },

    updateActiveRoute(newRoute) {
      LoggingService.debug('AdminPortalApp.updateActiveRoute');
      this.activeRoute = newRoute;
    },
  },
};
</script>

<style module>
@import './css/layout.css';
</style>
